// extracted by mini-css-extract-plugin
module.exports = {"Events":"events_Events__SluTP","CardsTable":"events_CardsTable__Vgw9D","filtersRow":"events_filtersRow__20huG","filterContainer":"events_filterContainer__27eKT"};